export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'portNo',
    align: 'center',
    width: 100,
    title: that.$l('master_port_portNo') || '港口编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'portName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('master_port_portName') || '港口名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'portRegion',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    title: that.$l('master_port_portRegion') || '国家代码',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'portCountry',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('master_port_portCountry') || '国家全称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'portFullName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('master_port_portFullName') || '港口全称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'portDesc',
    headerAlign: 'center',
    align: 'left',
    width: 250,
    title: that.$l('master_port_portDesc') || '港口说明',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: {default: 'status'},
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
